// extracted by mini-css-extract-plugin
export default {"userGeneratedCardContainer":"UserActionCardModal_userGeneratedCardContainer__2EWcs","tabsWithStatusWrapper":"UserActionCardModal_tabsWithStatusWrapper__MyoR1"};